// extracted by mini-css-extract-plugin
export default {"add_button":"Accounts_add_button__ysmek","accounts":"Accounts_accounts__dgcoX"};